module.exports = __webpack_public_path__ + "static/media/who-9.03a616a8.jpg";